import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ZBeamIconProps {
  size?: number;
  color?: string;
}

const ZBeamIcon: React.FC<ZBeamIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-zbeam">
    {
      <path d="M19.889 18.446h-5.915c-0.652 0-1.251-0.164-1.251-0.588v-13.020c0-0.019-0.005-0.037-0.015-0.053v-0.158h-8.567c-0.080 0-0.11 0.928-0.030 0.928h5.915c0.652 0 1.251 0.164 1.251 0.588v13.020c0 0.019 0.005 0.037 0.015 0.053v0.158h8.567c0.080 0 0.11-0.928 0.030-0.928z"></path>
    }  </SvgIcon>
);

export default ZBeamIcon;
